import { render, staticRenderFns } from "./RevokeConsentRequestListComponent.vue?vue&type=template&id=49afd79c"
import script from "./RevokeConsentRequestListComponent.vue?vue&type=script&lang=js"
export * from "./RevokeConsentRequestListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports